// eslint-disable-next-line @typescript-eslint/no-empty-function
export const noop = () => {}

/**
 * Do polling with given times and a interval
 *
 * @param fn a function to execute
 * @param times function execution counts
 * @param interval function execution interval in milliseconds
 */
export const doPolling = ({ fn, times, interval }: { fn: VoidFunction; times: number; interval: number }) => {
  let executionCounts = 0

  const intervalId = setInterval(() => {
    if (executionCounts >= times) {
      clearInterval(intervalId)
      return
    }

    executionCounts += 1
    fn()
  }, interval)
}
